import * as React from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { buildDashboardPath } from '@/lib/routes';

export const Route = createFileRoute('/_authed/$orgSlug/')({
  component: OrgIndexRedirect,
});

function OrgIndexRedirect() {
  const navigate = useNavigate();
  const { orgSlug } = Route.useParams();

  React.useEffect(() => {
    navigate({
      to: buildDashboardPath(orgSlug) as any,
      replace: true,
    });
  }, [navigate, orgSlug]);

  return null;
}
